<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="alertSuccess"
            @delete-item="deleteType"
            @deleted="alertDeleted"
            @cancel="item = false"
        ></view-item>

        <list-items
            v-else
            title="Order Categories"
            :items="categories"
            @show-item="showItem"
            ref="table"
        >
            <b-row v-if="hasPermissionCreate">
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" v-if="hasPermissionCreate" @click="item = {}"
                        >Add Category</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'orderCategories',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('orderCategory/fetchAll')
        },

        showItem(id) {
            const item = this.categories.find(x => x.id === id)
            this.item = {...item}
        },

        alertSuccess(isUpdated) {
            const message= isUpdated? 'Category Updated' : 'Category Created'
            this.doToast('Success', message, 'success')
            console.log('alert success message',message)
            this.item = null
            this.doSearch()
        },

        alertDeleted(){
            const message= 'Category Deleted'
            this.doToast('Success', message, 'success')
            console.log('alert success message',message)
            this.item = null
            this.doSearch()
        }
    },
}
</script>
<style></style>
